import { Avatar, AvatarGroup, Box, Link, Typography } from "@mui/material"

import React, { useContext, useMemo } from "react"
import { customPalette } from "../../../../../../../theme"
import { IconUsers } from "../../../../../../components/custom-icons/icon-users"
import { TabEnum } from "../../../../../../components/tabs/tabs"
import { toInitials } from "../../../../../../core/services/user-service"
import { TeamContext } from "../../TeamTab/context/TeamContext"

interface IProps {
  handleChange(event: React.SyntheticEvent, newValue: TabEnum, sendInvitation?: boolean): void
}

export function ProjectTeamCard({ handleChange }: Readonly<IProps>): React.JSX.Element {
  const { currentTeam } = useContext(TeamContext)

  const initialsTeamList: string[] = useMemo(
    () => currentTeam.map((collaborator) => toInitials(collaborator)),
    [currentTeam]
  )

  const colorTeam = useMemo(
    () => [customPalette.gray1, customPalette.darkGray1, customPalette.lightBlue2, customPalette.gray2],
    []
  )

  return (
    <Box
      display="flex"
      flexDirection="column"
      p={3}
      gap={2}
      border={2}
      borderRadius={2}
      borderColor={customPalette.lightGray1}
      width="100%">
      <Box display="flex" sx={{ borderRadius: 3 }}>
        <IconUsers sx={{ height: "50px", width: "50px", color: customPalette.darkBlue2 }} />
      </Box>
      <Typography variant="subtitle1" sx={{ color: customPalette.lightBlue5 }}>
        Équipe
      </Typography>

      <Box>
        <Typography variant="body2">Invitez des collaborateurs sur le projet</Typography>

        <Box sx={{ display: "flex" }}>
          <AvatarGroup
            max={5}
            slotProps={{
              additionalAvatar: {
                sx: { backgroundColor: customPalette.white, color: customPalette.black },
              },
            }}>
            {initialsTeamList.map((initial, index) => (
              <Avatar key={initial} sx={{ backgroundColor: colorTeam[index] }}>
                <Typography variant="body2" sx={{ color: customPalette.white }}>
                  {initial}
                </Typography>
              </Avatar>
            ))}
          </AvatarGroup>
          <AvatarGroup>
            <Avatar
              onClick={(e) => handleChange(e, TabEnum.PROJECT_TEAM, true)}
              sx={{
                backgroundColor: customPalette.lightGreen9,
                border: `2px dashed ${customPalette.lightGreen11} !important`,
                cursor: "pointer",
              }}>
              <Typography sx={{ color: customPalette.black }}>+</Typography>
            </Avatar>
          </AvatarGroup>
        </Box>

        <Box width="fit-content">
          <Link
            component="button"
            variant="body2"
            color={customPalette.black}
            textAlign="left"
            onClick={(e) => handleChange(e, TabEnum.PROJECT_TEAM)}>
            Voir l'équipe
          </Link>
        </Box>
      </Box>
    </Box>
  )
}
